export const ALL_TAGS_OPTION = { id: "__ALL__", name: "All" } as const;
export const NO_TAGS_OPTION = { id: "__NO_TAGS__", name: "No tags" } as const;
